(function () {
  'use strict';

  var locale = 'ar';

  function checkoutUrl(url) {
    if (!url) return url;
    var lower = String(url).toLowerCase();
    if (lower.indexOf('/checkout') === -1 && lower.indexOf('/checkouts/') === -1) return url;

    try {
      var abs = new URL(url, window.location.origin);
      abs.searchParams.set('locale', locale);
      return abs.pathname + abs.search + abs.hash;
    } catch (e) {
      if (url.indexOf('locale=') !== -1) {
        return url.replace(/([?&])locale=[^&]*/i, '$1locale=' + locale);
      }
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'locale=' + locale;
    }
  }

  function syncCheckoutCurrency() {
    var currency = window.Currency && window.Currency.cookie ? window.Currency.cookie.read() : null;
    if (!currency || currency === 'TRY') return;
    document.querySelectorAll('a[href*="/checkout"], a[href*="/checkouts/"], form[action="/checkout"]').forEach(function (el) {
      if (el.tagName === 'A') {
        el.setAttribute('href', checkoutUrl(el.getAttribute('href')));
      }
    });
  }

  function removeWishlist() {
    var selectors = [
      '.maxus-product__wishlist',
      '.btn-addwhlist',
      '.add-wishlist',
      'li.add-wishlist',
      '.engoj_add_to_wishlist',
      '.engoj_add_to_wishlist_pd',
      'a[href*="/pages/wishlist"]',
      'a[href*="/wishlist"]'
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var parent = el.closest('li.add-wishlist, .add-wishlist, .btn-addwhlist');
        (parent || el).remove();
      });
    });
  }

  function fixCheckoutLinks() {
    document.querySelectorAll('a[href*="/checkout"], a[href*="/checkouts/"]').forEach(function (link) {
      link.setAttribute('href', checkoutUrl(link.getAttribute('href')));
    });

    document.querySelectorAll('form[action="/cart"], form[action*="/cart"]').forEach(function (form) {
      if (form.dataset.turkwayCheckout === '1') return;
      form.dataset.turkwayCheckout = '1';
      form.addEventListener('submit', function (event) {
        var target = event.submitter || form.querySelector('[name="checkout"], .checkout-button, .button-checkout');
        if (!target) return;
        if (target.name !== 'checkout' && !target.classList.contains('checkout-button') && !target.classList.contains('button-checkout')) return;
        event.preventDefault();
        window.location.href = checkoutUrl('/checkout');
      });
    });
  }

  function run() {
    document.documentElement.setAttribute('lang', locale);
    document.documentElement.setAttribute('dir', 'rtl');
    removeWishlist();
    fixCheckoutLinks();
    syncCheckoutCurrency();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);

  var debounceTimer;
  new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
